import { getIcon } from "../utils/icons.js";

class SonikitDialog extends HTMLElement {
  #shadow

  constructor() {
    super();
    this.#shadow = this.attachShadow({ mode: 'closed' });
  }

  setContent(html) {
    if (this._contentEl) {
      if (html instanceof Node) {
        this._contentEl.appendChild(html);
      } else {
        this._contentEl.innerHTML = html;
      }
    }
  }

  open() {
    const dialog = this.#shadow.querySelector('dialog');
    dialog.showModal();
  }

  close() {
    const dialog = this.#shadow.querySelector('dialog');
    dialog.close();
  }

  async render(buttonColor) {
    const template = document.createElement('template');
    template.innerHTML = `
      <style>
        dialog {
          padding: 40px 20px 20px 20px;
          box-sizing: border-box;
          background-color: white;
          color: black;
          border: none;
          text-align: center;
          border-radius: 10px;
        }
        dialog::backdrop {
          background: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(10px);
        }
        .dialog__content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 10px;
          width: 100%;
          min-width: 200px;
          max-width: 400px;
        }
        .dialog__content button{
          width: 100%;
        }
        .dialog__content a {
          color: black;
          font-weight: 600;
        }
        .dialog__close {
          position: absolute;
          top: 10px;
          right: 10px;
          background: transparent;
          border: none;
          outline: none;
          padding: 0;
          cursor: pointer;
        }
        .dialog__close svg{
          width: 20px;
          height: 20px;
          fill: black;
          pointer-events: none;
        }

        button {
          display: flex;
          flex: 1 1 auto;
          justify-content: center;
          align-items: center;
          gap: 5px;
          text-align: center;
          text-transform: uppercase;
          font-weight: 700;
          box-sizing: border-box;
          padding: 8px 16px;
          border-radius: 50px;
          cursor: pointer;
          border: none;
          color: white;
          background-color: black;
        }

        button, button:focus {
          outline: none;
        }

        @media (max-width: 500px) {
          button {
            width: 100%;
          }
        }

        .wrapper[data-layout="stacked"] button{
          width: 100%;
          max-width: 300px;
        }
        
        button svg {
          width: 1.2em;
          height: 1.2em;
          fill: currentColor;
          pointer-events: none;
        }

        button[data-layout='text'] {
          background-color: transparent;
          color: black;
          font-weight: 800;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
          border: none;
          outline: none;
          cursor: pointer;
        }

        button[data-service="spotify"] {
          color: white;
          background-color: ${buttonColor === "default" ? "#1ED760" : buttonColor};
        }
        button[data-service="apple-music"] {
          color: white;
          background-color: ${buttonColor === "default" ? "#FF2E56" : buttonColor};
        }
        button[data-service="tidal"] {
          color: white;
          background-color: ${buttonColor === "default" ? "black" : buttonColor};
        }
        button[data-service="soundcloud"] {
          color: white;
          background-color: ${buttonColor === "default" ? "#fd561f" : buttonColor};
        }
        button[data-service="deezer"] {
          color: white;
          background-color: ${buttonColor === "default" ? "#B560FF" : buttonColor};
        }
        button[data-service="youtube"] {
          color: white;
          background-color: ${buttonColor === "default" ? "#FF0100" : buttonColor};
        }
        button[data-service="amazon-music"] {
          color: white;
          background-color: ${buttonColor === "default" ? "#4004F1" : buttonColor};
        }

        .actions {
          display: flex;
          justify-content: center;
          align-items: center;
          vertical-align: middle;
          flex-wrap: wrap;
          user-select: none;
          min-width: 100px;
          box-sizing: border-box;
          gap: 10px;
        }
        .wrapper[data-layout="stacked"] .actions {
          flex-direction: column;
          width: 100%;
        }
        @media (max-width: 500px) {
          .actions {
            flex-direction: column;
          }
        }
      </style>
      <dialog>
        <div class="dialog__content"></div>
        <button class="dialog__close">${getIcon('close')}</button>
      </dialog> 
    `

    this.#shadow.appendChild(template.content.cloneNode(true));
    this._contentEl = this.#shadow.querySelector('.dialog__content');

    const closeButton = this.#shadow.querySelector('.dialog__close');
    closeButton.addEventListener('click', () => this.close());

    sonikit.on('actionComplete', () => this.close());
  }
}

customElements.define('sonikit-dialog', SonikitDialog);